function PayoutMappingCtrl(toaster, $state, $auth, $stateParams, PayoutMappingService, AppSettings, CommonService) {
  'ngInject';
  const vm = this;
  vm.loading = false;
  vm.payoutMappingForm = $stateParams.mapping ? JSON.parse(JSON.stringify($stateParams.mapping)) : {};
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.saveLoading = false;
  vm.searchParams = {
    name: ($stateParams.name ? $stateParams.name : ''),
    accountName: ($stateParams.accountName ? $stateParams.accountName : ''),
    accountCode: ($stateParams.accountCode ? $stateParams.accountCode : '')
  };
  vm.orgIdMapping = $stateParams.id;
  vm.orgId = $stateParams.orgId;

  vm.init = function () {
    vm.dataloading = true;
    vm.getAmazonPayoutMappings();
    vm.getAccounts();
    vm.getTaxRates();
  };

  vm.getAmazonPayoutMappings = function () {
    vm.url = `/organizations/${$stateParams.orgId}/amazon_payout_mappings/${$stateParams.mappingId}/amazon_payout_mapping_accounts.json?page=${vm.pageNumber}&size=${vm.size}&by_name=${vm.searchParams.name}&by_account_name=${vm.searchParams.accountName}&by_account_code=${vm.searchParams.accountCode}&sort=${vm.sortBy}`;
    PayoutMappingService.getPayoutMappings($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
      vm.dataloading = false;
      if (response.status == 200) {
        vm.mappingResponse = response.data;
        vm.currentPage = !vm.mappingResponse.pagination ? 1 : vm.mappingResponse.pagination.current_page;
        vm.totalPages = !vm.mappingResponse.pagination ? 1 : vm.mappingResponse.pagination.total_page;
        vm.mappingTaxType = vm.mappingResponse.amazon_payout_mapping.tax_type;
        vm.mappingList = vm.mappingResponse.amazon_payout_mapping_accounts;
        vm.groupCategories();
        vm.mappingList.forEach(function (d) {
          d.account = d.account_code ? `${d.account_code} : ${d.account_name}` : undefined;
          d.tax = d.tax_name ? `${d.tax_name} (${d.tax_rate}%)` : undefined;
        });
      }
    });
  };

  vm.getAccounts = function () {
    CommonService.getAccounts($stateParams.orgId, function (response) {
      vm.accounts = response.data;
      vm.accounts.forEach(function (d) {
        d.account = `${d.code} : ${d.name}`;
      });
    });
  };

  vm.getTaxRates = function () {
    CommonService.getTaxRates($stateParams.orgId, function (response) {
      if (response.status == 200) {
        vm.taxRates = response.data;
        vm.taxRates.forEach(function (d) {
          d.tax = `${d.name} (${d.effective_rate}%)`;
        });
      }
    });
  };

  vm.groupCategories = function () {
    vm.categories = {};
    vm.mappingList.forEach(function (d) {
      let transactionType = d.name.split('-')[0];
      if (!(transactionType in vm.categories)) {
        vm.categories[transactionType] = [];
      }
      vm.categories[transactionType].push(d);
      if (d.account_code == '' || d.account_code == undefined || d.account_code == null) {
        vm.categories[transactionType]
      }
    });
  };

  vm.newMappingsExists = function (items) {
    return items.some(function (el) {
      return el.account == '' || el.account == undefined || el.account == null;
    });
  };

  vm.taxRateExists = function (items) {
    return items.some(function (el) {
      return (el.tax == '' || el.tax == undefined || el.tax == null ) && vm.mappingTaxType != 'no_tax';
    });
  };

  vm.savePayoutMapping = function (mappingForm) {
    vm.responseReceived = false;
    vm.saveLoading = true;
    let formData = {
      amazon_payout_mapping_account: {
        name: vm.payoutMappingForm.name,
        account_code: vm.payoutMappingForm.account_code.code,
        account_name: vm.payoutMappingForm.account_name.name
      }
    };
    if (vm.payoutMappingForm.tax_rate) {
      formData.amazon_payout_mapping_account.tax_rate = vm.payoutMappingForm.tax_rate.effective_rate;
      formData.amazon_payout_mapping_account.tax_name = vm.payoutMappingForm.tax_rate.name;
    }
    if ($stateParams.id && $stateParams.mapping) {
      PayoutMappingService.editPayoutMapping(formData, vm.orgId, $stateParams.id, $stateParams.mappingId, function (response) {
        vm.payoutMappingForm = {};
        vm.saveLoading = false;
        if (response.status >= 200 && response.status < 300) {
          $state.go('user.organization.settingView.mapping.payout-mapping', { inherit: false });
          toaster.pop('info', 'Amazon Payout Mapping updated.');
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    } else {
      PayoutMappingService.savePayoutMapping(formData, vm.orgId, $stateParams.mappingId, function (response) {
        vm.responseReceived = true;
        vm.saveLoading = false;
        vm.payoutMappingForm = {};
        mappingForm.$setPristine();
        mappingForm.$setUntouched();
        if (response.status >= 200 & response.status < 300) {
          toaster.pop('info', 'New Amazon Payout Mapping saved.');
          vm.init();
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  };


  vm.sortFlag = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        return false;
      }
    }
    return true;
  };

  vm.sort = function (param) {
    var currentSort = $stateParams.sortBy;
    if (currentSort && currentSort.includes(param)) {
      if (!currentSort.includes('-')) {
        param = '-' + param;
      }
    }
    $state.go('user.organization.settingView.mapping.payout-mapping', { sortBy: param });
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.mappingResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
    $state.go('user.organization.settingView.mapping.payout-mapping', { pageNumber: vm.pageNumber, size: vm.size });
  };

  vm.editMapping = function (mapping) {
    $state.go('user.organization.settingView.mapping.payoutNew', { orgId: $stateParams.orgId, id: mapping.id, mapping: mapping }, { inherit: false });
    $('html,body').animate({
      scrollTop: $("#payout_form").offset().top - 100
    },
      'slow');
  };

  vm.inlineSave = function (data, id) {
    let mappingItem = {
      amazon_payout_mapping_account: {
        name: data.name,
        id: id
      }
    };

    if (data.taxRate) {
      mappingItem.amazon_payout_mapping_account.tax_rate = data.taxRate.effective_rate;
      mappingItem.amazon_payout_mapping_account.tax_name = data.taxRate.name;
    }
    if (!(typeof data.account === 'string' || data.account instanceof String)) {
      mappingItem.amazon_payout_mapping_account.account_name = data.account.name;
      mappingItem.amazon_payout_mapping_account.account_code = data.account.code;
    }

    PayoutMappingService.editPayoutMapping(mappingItem, vm.orgId, id, $stateParams.mappingId, function (response) {
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', 'Account updated successfully.');
        let index = vm.mappingList.map(function (o) { return o.id; }).indexOf(response.data.id);
        vm.mappingList[index] = Object.assign({}, response.data, { 'account': `${d.account_code} : ${d.account_name}` , 'tax': `${d.tax_name} (${d.tax_rate}%)`});
        vm.groupCategories();
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.search = function () {
    $state.go('user.organization.settingView.mapping.payout-mapping', { pageNumber: 1, size: vm.size, name: vm.searchParams.name, accountName: vm.searchParams.accountName, accountCode: vm.searchParams.accountCode });
  };

  vm.deleteMapping = function (mappingId) {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this Amazon Payout Mapping?",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
    })
      .then(willDelete => {
        if (willDelete) {
          PayoutMappingService.deletePayoutMapping($stateParams.orgId, mappingId, $stateParams.mappingId, function (response) {
            vm.removePayoutMapping(mappingId);
            if (response.status == 204) {
              toaster.pop('info', 'Amazon Payout Mapping deleted.');
            } else {
              toaster.pop('error', CommonService.throwError(response));
            }
          });
        }
      });
  };

  vm.removePayoutMapping = function (mappingId) {
    for (var i = vm.mappingList.length - 1; i >= 0; i--) {
      if (vm.mappingList[i].id == mappingId) {
        vm.init();
      }
    }
  };

  vm.paginate = function (param) {
    vm.url = vm.mappingResponse.links[param];
    if (vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organization.settingView.mapping.payout-mapping', { pageNumber: vm.pageNumber, size: vm.size });
    }
  };

  vm.refreshResults = function ($select) {
    var search = $select.search,
      list = angular.copy($select.items),
      FLAG = -1;
    list = list.filter(function (item) {
      return item.id !== FLAG;
    });
    if (!search) {
      $select.items = list;
      $select.selected = undefined;
      $select.search = undefined;
    } else {
      var userInputItem = {
        id: FLAG
      };
      userInputItem[`${$select.$element.attr('elm')}`] = search;
      $select.items = [userInputItem].concat(list);
      $select.selected = userInputItem;
    }
  };

  vm.clearUISelect = function ($event, $select) {
    $event.stopPropagation();
    $select.selected = undefined;
    $select.search = undefined;
    $select.activate();
  };


}

export default {
  name: 'PayoutMappingCtrl',
  fn: PayoutMappingCtrl
};